'use client';
import type { CSSProperties, MouseEventHandler, ReactElement } from 'react';
import Link from 'next/link';
import { motion } from 'framer-motion';
import { ContainerPreset } from '@/constants/componentPresets';
import { ColorType } from '@/theme/colors';
import { Ccontainer } from '../Ccontainer';
import { Clogo } from '../Clogo';
const LOGO_CONTAINER_STYLE: CSSProperties = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
};
export interface NavbarLogoProps {
    isMobile: boolean;
    linkStyle: CSSProperties;
    logoSize: number;
    motionStyle: CSSProperties;
    onClick: MouseEventHandler<HTMLAnchorElement>;
    useContainerFrame?: boolean;
}
export function NavbarLogo({ isMobile, linkStyle, logoSize, motionStyle, onClick, useContainerFrame = false, }: NavbarLogoProps): ReactElement {
    const logo = (<Clogo dataElScope="Cpagelayout/NavbarLogo" size={logoSize} withText={!isMobile}/>);
    return (
      <Link href="/" onClick={onClick} style={linkStyle}>
        <motion.div whileTap={{ scale: 0.95 }} transition={{ duration: 0.1 }} style={motionStyle}>
          {useContainerFrame ? (<Ccontainer preset={ContainerPreset.Default} backgroundColor={ColorType.Transparent} backgroundOpacity={0} borderWidth={0} padding={0} style={LOGO_CONTAINER_STYLE}>
              {logo}
            </Ccontainer>) : logo}
        </motion.div>
      </Link>
    );
}
